
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles/index";
import { Modal, Button, Alert } from "react-bootstrap";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { useFormik } from "formik";
import ReactSelectMulti from "../../UI/ReactMultiSelect";


const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#072C8C",
  },
});
const initialValues = {
  roles: "",
};

export default function Edit(props) {
  const classes = useStyles();
  const {
    onHide,
    show,
    onUsers,
    chooseUserId,
    onUserChoose,
    skip,
    take,
    sortField,
    orderBy,
    filterInputs,
    roleId,
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [rolesOption, setRolesOption] = useState(null);
  const [oldValue, setOldValue] = useState([]);

  
  const onPutUser = (values, resetForm, setSubmitting) => {
    setIsEditLoading(true)

   
    const  userBody = {
       roles: oldValue 
      };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}user/role/${chooseUserId}`,
        userBody
      )
      .then(() => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onUsers(orderBy, sortField, skip, take, filterInputs,);
        setIsEditLoading(false)
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        setIsError(message);
        setIsEditLoading(false)
      });
     
  };

  // const EditSchema = Yup.object().shape({
  //   roles: Yup.string()
  //     .required("Rol tələb olunur."),
     
  // });


  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const formik = useFormik({
    initialValues,
    // validationSchema: EditSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPutUser(values, resetForm, setSubmitting);
    },
  });

  const { setFieldValue } = formik;
  
 

  useEffect(() => {
    setIsLoading(true);
    onUserChoose(chooseUserId)
      .then((res) => {
        const roles = res.data.role.map(
          ({ id, name }) => ({
            value: id,
            label: name,
          })
        );
        const oldValue = res.data.role.map(
          ({ id }) => id
        );
        setOldValue(oldValue);
        setRolesOption(roles);
       
        setFieldValue(
          "roles",
          res.data.roles ? res.data.roles : ""
        );

        setIsLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [chooseUserId, setFieldValue]);

  function handleChangeRoles(value) {
    setRolesOption(value);
    const mockArray = [];
    if (value){
      value.forEach(element => {
        mockArray.push(element.value);
      });
    }
   
    setOldValue(mockArray);
  }

  return (
    <Modal
      size="lg"
      aria-labelledby="edit"
      centered
      className="modal pr-0"
      show={show}
      onHide={onHide}
    >
      {isLoading ? (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      ) : !isLoading ? (
        <form onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title id="edit">Düzəliş et</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-12 pl-4 pr-4">
              <div className="row">
           

                <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <ReactSelectMulti
                    suggestions={roleId}
                    handleChangeSingle={handleChangeRoles}
                    single={rolesOption}
                    label="Rol seçin"
                    placeholder="Rol seçin"
                    inputId="roles"
                    error={getInputClasses("roles")}
                    {...formik.getFieldProps("roles")}
                  />
                     </div>
              {formik.touched.roles && formik.errors.roles ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors.roles}
                  </div>
                </div>
              ) : null}
                
                  {isError && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block MuiFormLabel-root Mui-error">
                        {isError}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                onHide(false);
                formik.resetForm();
              }}
            >
              Ləğv et
            </Button>
            <Button type="submit" className={isEditLoading ? "px-9" : ""}>
              <span>Düzəliş et</span>
              {isEditLoading && (
                <span className="ml-3 spinner spinner-white"></span>
              )}
            </Button>
          </Modal.Footer>
        </form>
      ) : (
        <div className="p-5">
          <Alert variant="info">Xəta baş verdi.</Alert>
        </div>
      )}
    </Modal>
  );
}
